import Swiper from 'swiper/bundle';

class LSGQuoteSlider extends HTMLElement {
    constructor() {
        super();
        this.classes = {
            swiper: 'js-lsg-quote-slider',
            swiperSlide: 'swiper-slide',
            wrapper: 'swiper-wrapper',
            navigation: {
                pagination: 'js-lsg-quote-slider-pagination',
                prev: 'js-lsg-quote-slider-prev',
                next: 'js-lsg-quote-slider-next',
            }
        }

        this.elements = {
            swiper: this.querySelector(`.${this.classes.swiper}`),
            slides: this.querySelectorAll(`.${this.classes.swiperSlide}`),
            wrapper: this.querySelector(`.${this.classes.wrapper}`),
            navigation: {
                pagination: this.querySelector(`.${this.classes.navigation.pagination}`),
                prev: this.querySelector(`.${this.classes.navigation.prev}`),
                next: this.querySelector(`.${this.classes.navigation.next}`),
            }
        }

        this.resizeHandler = this.handleResize.bind(this);
    }

    connectedCallback() {
        if(this.checkIfEmpty()) return;
        this.init();
        window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
        if(this.swiper) {
            this.swiper.destroy();
        }
        window.removeEventListener('resize', this.resizeHandler);
        if(this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
    }

    checkIfEmpty() {
        const listInner = this.elements.wrapper;
        if(!listInner || !listInner.children.length) {
            this.style.display = 'none';
            return true;
        }
        return false;
    }

    init() {
        if(!this.shouldInit()) return;
        this.initSwiper();
    }

    shouldInit() {
        if(!this.elements.swiper || !this.elements.slides.length) return false;
        const slidesCount = this.elements.slides.length;
        if(slidesCount <= 1) return false;

        return true;
    }

    handleResize() {
        if(this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(() => {
            const shouldInitialize = this.shouldInit();
            if(shouldInitialize && !this.swiper) {
                this.initSwiper();
            }else if(!shouldInitialize && this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }, 300);
    }

    initSwiper() {
        this.swiper = new Swiper(this.elements.swiper, {
            slidesPerView: 1,
            spaceBetween: 10,
            watchOverflow: true,
            navigation: {
                nextEl: this.elements.navigation.next,
                prevEl: this.elements.navigation.prev,
            },
            pagination: {
                el: this.elements.navigation.pagination,
                clickable: true
            }
        })
    }

}

if(!customElements.get('lsg-quote-slider')) {
    customElements.define('lsg-quote-slider', LSGQuoteSlider);
}